<template>
  <div class="item-modifier-quantity-adjuster-wrap">
    <button v-if="!isInStock(item)" class="mobile-btn btn btn-primary btn-block" disabled>
      {{ $t('outOfStock') }}
    </button>

    <button v-else-if="isInStoreOnly(item)" class="mobile-btn btn btn-primary btn-block" disabled>
      {{ $t('inStoreOnly') }}
    </button>

    <button
      v-else-if="getMinimumQuantity(item).comparedTo(0) <= 0"
      class="mobile-btn btn btn-primary btn-block"
      disabled
    >
      {{ $t('notAvailable') }}
    </button>
    <div
      v-else-if="!quantity(item, variationId).isZero()"
      class="wc-atc-btn__adjuster-wrapper border-primary text-primary bg-white"
    >
      <!-- START : Quantity adjuster decrement button -->
      <button
        class="btn py-0 px-1 border-0"
        :class="isNextDecrementValid(item, variationId) ? 'text-primary' : 'text-muted'"
        @click="decrement(item, variationId)"
        :disabled="!isNextDecrementValid(item, variationId)"
        :aria-label="$t('decreaseQuantity')"
        :aria-describedby="describedBy"
      >
        <font-awesome-icon
          v-if="getNextDecrement(item, variationId).isZero()"
          icon="trash"
          size="sm"
        />
        <font-awesome-icon v-else icon="minus" size="sm" />
      </button>
      <!-- END : Quantity adjuster decrement button -->

      <!-- Quantity adjuster display quantity -->
      <span class="wc-atc-btn__quantitiy-label">{{ quantity(item, variationId) }}</span>
      <!-- START : Quantity adjuster increment button -->
      <button
        class="btn py-0 px-1 border-0"
        :class="isNextIncrementValid(item, variationId) ? 'text-primary' : 'text-muted'"
        @click="increment(item, variationId)"
        :disabled="!isNextIncrementValid(item, variationId)"
        :aria-label="$t('increaseQuantity')"
        :aria-describedby="describedBy"
        ref="incrementButtonRef"
      >
        <font-awesome-icon icon="plus" size="sm" />
      </button>
      <!-- END : Quantity adjuster increment button -->
    </div>
    <!-- Quantity adjuster add to cart button -->
    <!-- START : MTO Customize Button -->
    <WCCustomizeButton
      v-else-if="(item.hasModifiers || item.hasLinkedItems) && !variationId"
      class="btn-block"
      :item="item"
    />
    <!-- END : MTO Customize Button -->
    <!-- START: Add to Cart Button -->
    <template class="mto-item-cart-btn-wrap" v-else>
      <button
        v-on="$listeners"
        class="btn btn-block d-flex"
        :class="linkButtonType ? 'wc-add-to-cart-link__button' : 'wc-add-to-cart__button'"
        @click="onClickAddToCart(item, lineItem, variation)"
        :aria-describedby="describedBy"
      >
        <span><!-- Invisible element for flexing center and right --></span>

        <span :class="linkButtonType && 'order-2'">
          {{ editingItem ? $t('applyChanges') : $t('addToCart') }}</span
        >
        <font-awesome-icon
          :class="linkButtonType && 'order-1 mt-1 mr-1'"
          icon="cart-shopping"
          size="sm"
        />
      </button>
    </template>
    <!-- END: Add to Cart Button -->
  </div>
</template>
<script>
import ItemModifierAddToCartMixin from '@/modules/itemModifiers/mixins/ItemModifierAddToCartMixin';
import WCCustomizeButton from '@/modules/cart/components/WCCustomizeButton/WCCustomizeButton.vue';
import CartControlsMixin from '@/modules/cart/mixins/CartControls/CartControls';

export default {
  name: 'WCItemModifierAddToCartQuantityAdjuster',
  data() {
    return {
      total: {
        type: Number,
      },
      currentSelectedQuantity: 0,
    };
  },
  components: { WCCustomizeButton },
  props: {
    item: {},
    lineItem: {},
    editingItem: { type: Boolean },
    instructions: {},
    variation: {
      type: Object,
    },
    describedBy: {
      type: String,
    },
    linkButtonType: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    variationId() {
      return this.variation ? this.variation.id : this.variation;
    },
  },
  mixins: [CartControlsMixin, ItemModifierAddToCartMixin], // Mixin for cart actions and add to cart
  methods: {
    /**
     * Method to call on clicking add to cart button - increment and move focus to increment button
     */
    onClickAddToCart(item, lineItem, variation) {
      this.addItemModifierToCart(item, lineItem, variation);
      this.$nextTick(() => {
        this.$refs?.incrementButtonRef?.focus();
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-atc-btn {
  display: flex;
}

.wc-add-to-cart__button {
  color: var(--primary-contrast, get-color-contrast('primary'));
  background-color: var(--primary, $primary);
  border-color: var(--primary, $primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.wc-add-to-cart-link__button {
  min-width: 6.5rem;
  color: var(--primary, $primary);
  margin: 0.375rem 0.5rem;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
}

.item-modifier-quantity-adjuster-wrap {
  .wc-add-to-cart-item__button {
    margin: 0.375rem 0.5rem;
  }
}

// Styling should closely match the Bootstrap outline button
.wc-atc-btn__adjuster-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: transparent;
  border: 1px solid;
  padding: $pad-3 * 0.375 $pad-3 * 0.75;
  font-size: $font-size-base;
  line-height: 1.5;
  border-radius: 0.25rem;
}

@include media-breakpoint-down(sm) {
  .wc-atc-btn__quantitiy-label {
    padding: 0rem 0.75rem;
  }
}
</style>
